import React from "react";

function RecordsaleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <defs>
        <path id="path-1" d="M0 0L16 0 16 16 0 16z"></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <mask id="mask-2" fill="#fff">
            <use xlinkHref="#path-1"></use>
          </mask>
          <path
            fill="#FFF"
            d="M8 7c-.553 0-1 .444-1 1s.447 1 1 1c.553 0 1-.445 1-1 0-.555-.447-1-1-1m0 3.972c-1.657 0-3-1.344-3-2.972s1.343-3 3-3a3 3 0 013 3c0 1.656-1.344 2.972-3 2.972M2.523 8h-.035a.495.495 0 01-.486-.542 6.03 6.03 0 015.476-5.456.492.492 0 01.522.5.496.496 0 01-.446.5 5.022 5.022 0 00-4.55 4.542.493.493 0 01-.481.456M8 0a8 8 0 00-8 8 8 8 0 008 8 8 8 0 008-8 8 8 0 00-8-8"
            mask="url(#mask-2)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default React.memo(RecordsaleIcon);
